import React from 'react';

function NoTreat() {
	return (
		<div className="practiceManagementForm" style={{ border: '1px solid #dadada' }}>
			<div className="noDataFound">
				<p>No Treatments Found</p>
			</div>
		</div>
	);
}
export default NoTreat;
